export const GOLD_TRADER_PRESENT = 'GOLD_TRADER_PRESENT'
export const GOLD_TRADER_HISTORY_GRAPH = 'GOLD_TRADER_HISTORY_GRAPH'
export const GOLD_HISTORY_LIST = 'GOLD_HISTORY_LIST'
export const GOLD_SPOT_LAST_QUOTE = 'GOLD_SPOT_LAST_QUOTE'
export const GOLD_SPOT_REAL_TIME = 'GOLD_SPOT_REAL_TIME'
export const GOLD_SPOT_REAL_TIME_GRAPH = 'GOLD_SPOT_REAL_TIME_GRAPH'
export const GOLD_SPOT_HISTORY_GRAPH = 'GOLD_SPOT_HISTORY_GRAPH'
export const GOLD_SPOT_PREVIOUS_CLOSE = 'GOLD_SPOT_PREVIOUS_CLOSE'
export const GOLD_SPOT_AGGREGATE_GRAPH = 'GOLD_SPOT_AGGREGATE_GRAPH'
export const GOLD_SPOT_GLOBAL_GRAPH_SETTING = 'GOLD_SPOT_GLOBAL_GRAPH_SETTING'
export const GOLD_SPOT_THAI_AGGREGATE_GRAPH = 'GOLD_SPOT_THAI_AGGREGATE_GRAPH'
export const GOLD_SPOT_THAI_REAL_TIME_GRAPH = 'GOLD_SPOT_THAI_REAL_TIME_GRAPH'
export const GOLD_TRADER_REAL_TIME_GRAPH = 'GOLD_TRADER_REAL_TIME_GRAPH'
export const GOLD_SPOT_THAI_REALTIME_CURRENT_PERIOD = 'GOLD_SPOT_THAI_REALTIME_CURRENT_PERIOD'
